import { useEffect, useState } from 'react';

import { WEBSITE } from './edition.js';

/**
 * The technical chat (tool lines, thinking, call inspector, model and effort
 * controls) for the operator only. Everyone else sees Prisma's streamlined
 * chat. Desktop only, off by default; Ctrl+Alt+Shift+D flips it. Never on the
 * website.
 */

const KEY = 'prism.devDetails';

function read(): boolean {
  if (WEBSITE) return false;
  try {
    return localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

export function useDevDetails(): boolean {
  const [on, setOn] = useState(read);
  useEffect(() => {
    if (WEBSITE) return;
    const key = (event: KeyboardEvent) => {
      if (!(event.ctrlKey && event.altKey && event.shiftKey && event.code === 'KeyD')) return;
      event.preventDefault();
      const next = !read();
      try {
        localStorage.setItem(KEY, next ? '1' : '0');
      } catch {
        // this window only
      }
      window.dispatchEvent(new Event('prism-dev-details'));
    };
    const changed = () => setOn(read());
    window.addEventListener('keydown', key);
    window.addEventListener('prism-dev-details', changed);
    return () => {
      window.removeEventListener('keydown', key);
      window.removeEventListener('prism-dev-details', changed);
    };
  }, []);
  return on;
}
